import { IconButton, InputAdornment } from "@mui/material";
import Input from "../Input/Input";
import Icon from "../Icon/Icon";
import { memo } from "react";

const SelectInput = memo(({ label, value, onClickSearch, hiddenSearch = false, hiddenDelete = false, isDisabled = false }) => {
    return (
        <Input
            formControlProps={{
                sx: {
                    width: '100%',
                }
            }}
            disabled={isDisabled}
            fullWidth
            value={value}
            label={label}
            onClick={() => isDisabled ? null : onClickSearch('search')}
            inputBaseProps={{
                sx: {
                    cursor: isDisabled ? 'default !important' : 'pointer !important',
                },
                readOnly: true,
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                onClickSearch('delete');
                            }}
                            hidden={isDisabled ? true : hiddenDelete}
                        >
                            <Icon
                                iconName={'close'}
                                svgIconProps={{
                                    fontSize: 'small',
                                    htmlColor: '#BE2957',
                                    sx: {
                                        height: '12px',
                                        width: '12px',
                                    }
                                }}
                            />
                        </IconButton>

                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                onClickSearch('search');
                            }}
                            disableRipple
                            disableFocusRipple 
                            hidden={isDisabled ? true : hiddenSearch}
                        >
                            <Icon
                                iconName={'search'}
                                svgIconProps={{
                                    fontSize: 'small',
                                    htmlColor: '#0087C2',
                                    sx: {
                                        height: '12px',
                                        width: '12px',
                                    }
                                }}
                            />
                        </IconButton>
                    </InputAdornment>
                )
            }}
        />
    )
});

export default memo(SelectInput);